import { useQuery } from 'react-query';
import { get } from '../fetch';
import { appendPreviewDate } from '../helper';

interface ZipCodeResponse {
  store: IStore;
  adjacentStores: IStore[] | null;
}

export const useGetStoreByPostal = (postal: string | null, adjacent: boolean = false) => {
  const url = appendPreviewDate(`/bff/api/store/zipcode/${postal}?includeAdjacent=${adjacent}`);

  return useQuery(['stores', 'postal', postal], () => get<ZipCodeResponse>(url), {
    enabled: !!postal,
    retry: false,
    retryOnMount: false,
    refetchOnWindowFocus: false,
  });
};

export const useGetAdjacentStores = (storeId: string | null) => {
  const url = appendPreviewDate(`/bff/api/store/${storeId}/adjacentstores`);

  return useQuery(['stores', 'adjacent', storeId], () => get<IStore[]>(url), {
    enabled: !!storeId,
    retry: false,
    retryOnMount: false,
    refetchOnWindowFocus: false,
  });
};

export const useGetStore = <T = ILimitedStore>(id?: string | null, suspense?: boolean) => {
  const url = appendPreviewDate(`/bff/api/store/${id}`);

  return useQuery(
    ['store', id],
    () =>
      get<T>(url).catch((err) => {
        if (err.status === 404) {
          return undefined;
        }
      }),
    {
      enabled: !!id,
      suspense,
    },
  );
};

export const useGetAllStores = <T = ILimitedStore>(suspense?: boolean) => {
  const url = appendPreviewDate(`/bff/api/store`);

  return useQuery('stores', () => get<T[]>(url), {
    suspense,
  });
};
